import React, { useState } from 'react'
import Icon from 'components/Icon'
import DateTimeInput from 'react-datetime'

const DateTime = ({ attribute, state, onChange }) => {
  const [errors, setErrors] = useState([])
  const { key, name, options, disabled, title } = attribute

  return (
    <fieldset className="space-y-1">
      <div className="flex gap-2 items-center">
        <p className="text-xs font-medium text-gray-600 uppercase tracking-wider">
          { name }
        </p>
        {title && (
          <Icon
            icon="info-circle"
            title={title}
            className="text-primary hover:text-secondary"
          />
        )}
      </div>
      <DateTimeInput
        value={state * 1000}
        onChange={(value) => onChange(Math.round(new Date(value).getTime() / 1000))}
        className="rounded-sm border border-gray-300 px-4 py-3"
        closeOnTab
        closeOnSelect
      />

      { state && state.length && errors.map((error) => (
        <small className="text-sm font-medium text-blue-500 block">
          { error } <Icon icon="exclamation-circle" />
        </small>
      )) }
    </fieldset>
  )
}

export default DateTime
